import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ten-process-result',
  templateUrl: './process-result.component.html',
  styleUrls: ['./process-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, MatIconModule],
})
export class ProcessResultComponent {
  @Input() public result: 'success' | 'failure';
  @Input() public useImageIcon: boolean;
}
